module.exports = __webpack_public_path__ + "img/stop-button.093fc1a1.svg";